import { render } from "./Adjust.vue?vue&type=template&id=50489c9b&scoped=true"
import script from "./Adjust.vue?vue&type=script&lang=js"
export * from "./Adjust.vue?vue&type=script&lang=js"

import "./Adjust.vue?vue&type=style&index=0&id=50489c9b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50489c9b"]])

export default __exports__